import React, { useEffect, useRef, useState } from "react";
import {
  allColumns,
  itemsInputField as inputFieldsInit,
} from "../Tab/ListCandidateDirectory.config";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { ColumnProps } from "../../../../../types/models";
import {
  ColumnPopoverDisplay,
  ExpandSearch,
  ListActionButton,
} from "../../../../../components/common";
import { Button, Col, message, Popover, Row, Space, Typography } from "antd";
import Icons from "../../../../../assets/icons";
import { ExcelSVG } from "../../../../../assets";
import {
  getChucVuAPI,
  getNoiCap,
  getWord,
  searchCandidateDirectory,
} from "../../../../../redux/reducer/employee";
import "./Color.scss";
import { employeeService } from "api";
import ModalCustom from "../../../../../components/common/ModalCustom/ModalCustom";
import FormEdit from "./FormEdit/FormEdit";
import FormAdd from "./FormAdd/FormAdd";
import Notification from "../../../../../components/common/notification/notification";
import axiosClient from "../../../../../api/_";
import {
  generateFileName,
  saveTableOptions,
  getTableOptions,
  formatDateToString,
} from "../../../../../helper/common";
import { RangePickerProps } from "antd/es/date-picker";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import { FORMAT_TIME } from "types/enums";
import { setButtonsHeader } from "redux/reducer/common";
import FormTemplates from "./FormTemplates";
const ListCandidateDirectory = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState<any[]>([]);
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 1000,
  });
  const modalRefFormTemplates = useRef(null);
  const [loading, setLoading] = useState(false);
  let savedTableOption = getTableOptions(
    "LISTCANDIDATEDIRECTORY_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? allColumns.map((cl) => {
        if (savedTableOption.some((it) => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(
            (it) => it.dataIndex === cl.dataIndex
          );
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : allColumns;
  const [columns, setColumns] = useState<any>(
    defaultColumns.filter((e) => e.show == true)
  );
  columns.map((e) => {
    if (e.key == "index") {
      e.render = (text, record, index) => {
        const rowNumber = (currentPage - 1) * params.limit + index + 1;
        return rowNumber;
      };
    }
  });
  const [paramss, setParamss] = useState<any>({});
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [type, setType] = useState("");
  const [record, setRecord] = useState(null);
  const dispatch = useAppDispatch();
  const expandRef = useRef<any>();
  const employees = useAppSelector((state) => state.employeesReducer);
  const [fieldInfo, setFieldInfo] = useState(inputFieldsInit);
  const modalRef = useRef<any>();
  const modalRefAdd = useRef<any>();
  const onClickSearch = async () => {
    setCurrentPage(1);
    // var searchFields = expandRef?.current?.getData();
    // setParams({ ...params, ...searchFields, page: 1 }); // Đặt trang về 1 khi thực hiện tìm kiếm
    const formValue = expandRef?.current?.getData();
    const searchFields = {
      ...formValue,
      ngayPhongVanTu: formatDateToString(
        formValue.ngayPhongVanTu,
        FORMAT_TIME.timeDetail
      ),
      ngayPhongVanDen: formatDateToString(
        formValue.ngayPhongVanDen,
        FORMAT_TIME.timeDetail
      ),
      //  end: formatDateToString(formValue.end, FORMAT_TIME.dayFull),
    };
    setParams({ ...formValue, ...params, ...searchFields, page: 1 });
  };
  useEffect(() => {}, [record]);
  useEffect(() => {
    getList({
      ...params,
    });
  }, [params]);

  useEffect(() => {
    columns.map((index) => {
      if (index.dataIndex === "trangThai") {
        index.render = (v, r, i) => {
          const valueMap = {
            "0": "Đăng ký",
            "1": "Đã trúng tuyển",
            "2": "Không trúng tuyển",
            "3": "Tiềm năng",
          };
          const backgroundColors = {
            "Tiềm năng": "#3380FF",
            "Đã trúng tuyển": "#198754",
            "Đăng ký": "#00b335",
            "Không trúng tuyển": "#f00c0c",
          };
          const displayValue = valueMap[v] || v; // Use the mapped value if available, otherwise use the original value
          const backgroundColor = backgroundColors[displayValue] || "";
          return (
            <div className="color-column" style={{ backgroundColor }}>
              {displayValue}
            </div>
          );
        };
      }
    });
  }, []);
  const getList = async (params) => {
    setLoading(true);
    setSelectedRowKeys([]);
    await dispatch(searchCandidateDirectory(params));
    setLoading(false);
  };

  useEffect(() => {
    setData(
      employees.CandidateDirectoryList.map((list) => ({
        ...list,
        key: list.id,
      }))
    );

  }, [employees.CandidateDirectoryList]);

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      const record = selectedRows[0];
      setSelectedRowKeys(selectedRowKeys);
      //  dispatch();
    },
  };
  const setShowColumnsList = (showColumns) => {
    saveTableOptions(
      "LISTCANDIDATEDIRECTORY_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };
  const setShowColumns = (showColumns: React.SetStateAction<ColumnProps[]>) => {
    setColumns(showColumns);
  };

  const onChangePagination = (currentPage, pageSize) => {
    setCurrentPage(currentPage);
    setParams({ ...params, page: currentPage, limit: pageSize });
  };
  const onClickExport = async () => {
    var searchFields = expandRef?.current?.getData();
    setParamss({ ...paramss, ...searchFields });
    handleExportExcel();
  };

  useEffect(() => {
    dispatch(
      getChucVuAPI({
        page: 1,
        limit: 1000,
      })
    );
    dispatch(getNoiCap());
    dispatch(
      getWord({
        page: 1,
        limit: 1000,
      })
    );
  }, []);

  useEffect(() => {
    setOptionsVTFields(employees.chucVuList, "viTriUngTuyen");
  }, [employees.chucVuList]);
  const setOptionsVTFields = (list, tenChucVu) => {
    if (fieldInfo.find((field) => field.name === tenChucVu)) {
      fieldInfo.find((field) => field.name === tenChucVu).options = list?.map(
        (item) => ({
          value: item.tenChucVu,
          label: item.tenChucVu,
        })
      );
      setFieldInfo([...fieldInfo]);
    }
  };
  useEffect(() => {
    const disabledDateStart: RangePickerProps["disabledDate"] = (
      currentDate
    ) => {
      const endDay = expandRef.current.getData()?.ngayPhongVanDen;
      if (endDay) {
        return currentDate > endDay;
      }
    };
    const disabledDateEnd: RangePickerProps["disabledDate"] = (currentDate) => {
      const start = expandRef.current.getData()?.ngayPhongVanTu;
      if (start) {
        return currentDate < start;
      }
    };
    inputFieldsInit.find((e) => e.name == "ngayPhongVanTu").disabledDate =
      disabledDateStart;
    inputFieldsInit.find((e) => e.name == "ngayPhongVanDen").disabledDate =
      disabledDateEnd;
    setFieldInfo([...inputFieldsInit]);
  }, []);
  useEffect(() => {
    dispatch(setButtonsHeader([]));
  }, []);
  const handleExportExcel = async () => {
    const url = "hanhchinhnhansu/danh-muc-ung-vien/export-excel";
    const baseName = "danh-sach-ung-vien";
    const fileExtension = "xlsx";
    const fileName = generateFileName(baseName, fileExtension);
    try {
      const response = await axiosClient.post(url, params, {
        responseType: "blob",
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      Notification("error", "Error exporting Excel");
    }
  };
  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };
  const deleteCandidateDirector = async (id) => {
    try {
      const res = await employeeService.deleteCandidateDirectory(id);
      message.success("Đã xóa dữ liệu vừa chọn");
      getList(params);
    } catch (error) {
      message.error("Đã xảy ra lỗi khi xóa dữ liệu");
    }
  };
  useEffect(() => {
    const newColumns = columns;
    columns.find((e) => e.dataIndex == "action").render = (
      value,
      _record,
      index
    ) => {
      return (
        <ListActionButton
          deleteFunction={() => {
            deleteCandidateDirector(_record.id);
          }}
          editFunction={() => {
            setType("Xem chi tiết");
            setRecord(_record);
            modalRef.current?.openModal();
          }}
        ></ListActionButton>
      );
    };

    setColumns(newColumns);
  }, []);
  // Xác định độ dài của mảng columns
  const numberOfColumns = columns.length;

  // Thiết lập giá trị scroll dựa vào số lượng cột
  let scrollX;
  if (numberOfColumns <= 4) {
    scrollX = 1000;
  } else {
    scrollX = 2000;
  }

  const renderTemplateButton = () => {
    if (selectedRowKeys.length) {
      return (
        <Button
          className="custom-btn"
          type="default"
          onClick={() => modalRefFormTemplates.current.openModal()}
          icon={<ExcelSVG />}
        >
          <Typography>Mẫu in</Typography>
        </Button>
      );
    } else return null;
  };
  return (
    <div
      className="candidate-directory-list"
      onKeyDown={onKeyDown}
      tabIndex={0}
    >
      <div className="candidate-directory-container">
        <div className="container">
          <ExpandSearch
            ref={expandRef}
            fields={fieldInfo}
            onClickSearch={onClickSearch}
            // Ẩn nút "Tìm kiếm nâng cao"
            isSearchExpend={false}
            isResetField={false}
          />
        </div>
        <div className="container">
          <Space style={{ width: "100%" }} direction="vertical">
            {/*<Typography.Text strong>Danh sách nhân viên</Typography.Text>*/}
            {/*<Divider type="horizontal" style={{ margin: "0" }} />*/}
            <Row justify={"space-between"} gutter={[16, 8]}>
              <Col>
                <Popover
                  trigger="click"
                  placement="topLeft"
                  content={
                    <ColumnPopoverDisplay
                      setShowColumns={setShowColumns}
                      columns={columns}
                      width={"400px"}
                    ></ColumnPopoverDisplay>
                  }
                >
                  <Button
                    icon={<Icons.bars />}
                    className="btn-sub"
                    type="primary"
                  >
                    Cột hiển thị
                  </Button>
                </Popover>
              </Col>
              <Col>
                <Space style={{ width: "100%" }}>
                  {renderTemplateButton()}
                  <Button
                    className="custom-btn"
                    type="default"
                    onClick={onClickExport}
                    icon={<ExcelSVG />}
                  >
                    <Typography>Xuất báo cáo</Typography>
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => {
                      setType("Thêm");
                      setRecord(null);
                      modalRefAdd.current?.openModal();
                    }}
                  >
                    Thêm mới
                  </Button>
                </Space>
              </Col>
            </Row>
            {data && (
              <CustomResizableTable
                rowSelection={{
                  type: "radio",
                  ...rowSelection,
                }}
                setShowColumns={setShowColumnsList}
                pagination={{
                  position: ["bottomRight"],
                  showSizeChanger: true,
                  total: employees.CandidateDirectoryTotal,
                  onChange: onChangePagination,
                  current: currentPage,
                }}
                onRow={(record, rowIndex) => {
                  return {
                    // onDoubleClick: e => handleView(record.id),
                  };
                }}
                rowKey={(record) => record.id}
                columns={columns}
                dataSource={data}
                bordered={true}
                loading={loading}
                scroll={{ x: scrollX }}
              />
            )}
            <ModalCustom
              ref={modalRef}
              width={1600}
              title={`${type} ứng viên`}
              centered
            >
              <FormEdit
                data={record}
                getListApi={getList}
                type={type}
                setCurrentPage={null}
              ></FormEdit>
            </ModalCustom>
            <ModalCustom
              ref={modalRefAdd}
              width={1600}
              title={`${type} ứng viên`}
              centered
            >
              <FormAdd
                data={record}
                getListApi={getList}
                type={type}
                setCurrentPage={null}
              ></FormAdd>
            </ModalCustom>
            <ModalCustom
              ref={modalRefFormTemplates}
              width={800}
              title={`${type} `}
              centered
            >
              <FormTemplates hdId={selectedRowKeys[0]} />
            </ModalCustom>
          </Space>
        </div>
      </div>
    </div>
  );
};

export default ListCandidateDirectory;
